import { SidebarGroup, CourseDef, Lesson } from './types';
import { module1Name, module1Courses, module1CoursesSidebar } from './modules/module1';
import { module2Name, module2Courses } from './modules/module2';
import { module3Name, module3Courses } from './modules/module3';

import { boasVindas } from './modules/module1/courses/boasVindas/_index';
import { salaDeSinaisAoVivo } from './modules/module1/courses/salaDeSinaisAoVivo/_index';
import { comecandoNasOpcoesBinarias } from './modules/module1/courses/comecandoNasOpcoesBinarias/_index';
import { aMelhorCorretora } from './modules/module1/courses/aMelhorCorretora/_index';
import { principiosDoTrader } from './modules/module1/courses/principiosDoTrader/_index';
import { mindsetDoTrader } from './modules/module1/courses/mindsetDoTrader/_index';
import { gestaoFinanceira } from './modules/module1/courses/gestaoFinanceira/_index';
import { introducaoTecnica } from './modules/module2/courses/introducaoTecnica/_index';
import { priceAction } from './modules/module2/courses/priceAction/_index';
import { padroesDeVelas } from './modules/module2/courses/padroesDeVelas/_index';
import { indicadoresTecnicos } from './modules/module2/courses/indicadoresTecnicos/_index';
import { tradeNaPratica as tradeNaPratica2 } from './modules/module2/courses/tradeNaPratica/_index';
import { masterclassAoVivo } from './modules/module2/courses/masterclassAoVivo/_index';
import { realityTrader } from './modules/module3/courses/realityTrader/_index';
import { estrategiasOTC } from './modules/module3/courses/estrategiasOTC/_index';
import { tradeNaPratica as tradeNaPraticaM3 } from './modules/module3/courses/tradeNaPratica/_index';

export type ModuleDef = { name: string; courses: CourseDef[]; sidebar: SidebarGroup[] };

export const modules: ModuleDef[] = [
  { name: module1Name, courses: module1Courses, sidebar: module1CoursesSidebar },
  { name: module2Name, courses: module2Courses, sidebar: module2Courses.map(g => ({
    title: g.courseTitle,
    countLabel: `${g.lessons.length} aulas`,
    items: g.lessons.map(l => ({ label: l.title, href: `/area/produto/item/${l.itemId}` })),
  })) },
  { name: module3Name, courses: module3Courses, sidebar: module3Courses.map(g => ({
    title: g.courseTitle,
    countLabel: `${g.lessons.length} aulas`,
    items: g.lessons.map(l => ({ label: l.title, href: `/area/produto/item/${l.itemId}` })),
  })) },
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _parseItemId = (href?: string): string | null => {
  if (!href) return null;
  const h = href.split('?')[0];
  const parts = h.split('/').filter(Boolean);
  return parts[parts.length - 1] || null;
};

// Mapa itemId -> módulo
export const itemToModule = (() => {
  const map = new Map<string, ModuleDef>();
  modules.forEach((m) => {
    m.courses.forEach((c) => c.lessons.forEach((l) => {
      if (l.itemId) map.set(l.itemId, m);
    }));
  });
  return map;
})();

// Lessons registry consolidado (top-level)

export const lessonsById: Record<string, Lesson> = {};
[
  // módulo 1
  boasVindas,
  salaDeSinaisAoVivo,
  comecandoNasOpcoesBinarias,
  aMelhorCorretora,
  principiosDoTrader,
  mindsetDoTrader,
  gestaoFinanceira,
  // módulo 2
  introducaoTecnica,
  priceAction,
  padroesDeVelas,
  indicadoresTecnicos,
  tradeNaPratica2,
  masterclassAoVivo,
  // módulo 3
  realityTrader,
  estrategiasOTC,
  tradeNaPraticaM3,
].forEach(course => {
  course.lessons.forEach(lesson => { lessonsById[lesson.itemId] = lesson; });
});

export const getModuleByItemId = (itemId?: string): ModuleDef | undefined => {
  if (!itemId) return undefined;
  return itemToModule.get(itemId);
};

// Reduce console pollution
const logProcessedData = (data: any[]) => {
  if (data.length > 0) {
    console.log('Resultado processado:', data);
  } else {
    console.log('Nenhum dado processado.');
  }
};

// Replace noisy logs
console.log('Dados retornados:', []);
logProcessedData([]);

